// useHeaderHeightVar.js
import { useEffect, useRef } from 'react';

export default function useHeaderHeightVar() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const set = () => {
      // 実高（枠線込み）を --header-height に反映
      const h = el.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    };

    set();
    const ro = new ResizeObserver(set);
    ro.observe(el);

    window.addEventListener('load', set);
    window.addEventListener('resize', set);

    return () => {
      ro.disconnect();
      window.removeEventListener('load', set);
      window.removeEventListener('resize', set);
    };
  }, []);

  return ref; // <header ref={...}>
}
